/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/9/24
 * Time: 10:40
 * Desc: 订单管理
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { parseSec, showPlatform } from '@/util';

export enum GO_RETURN_STATE {
  CHECKING = 1,
  CHECKED_SUCCESS_RETURNING,
  CHECKED_FAILED,
  RETURNED_SUCCESS,
  RETURNED_FAILED,
  CHECKING_MONEY,
  CHECKED_MONEY_SUCCESS,
  RETURNED_MONEY_SUCCESS,
  RETURNED_MONEY_FAILED,
  RETURNED_CANCEL,
  RETURNED_MONEY_CANCEL,
  FINISHED = 100,
}
const GOrderReturnStateText = [
  { label: '退货申请待审核', value: GO_RETURN_STATE.CHECKING },
  { label: '审核退货成功,退货中', value: GO_RETURN_STATE.CHECKED_SUCCESS_RETURNING },
  { label: '审核退货失败', value: GO_RETURN_STATE.CHECKED_FAILED },
  { label: '退货成功', value: GO_RETURN_STATE.RETURNED_SUCCESS },
  { label: '退货失败', value: GO_RETURN_STATE.RETURNED_FAILED },
  { label: '申请退款中', value: GO_RETURN_STATE.CHECKING_MONEY },
  { label: '审核退款成功,等待退款', value: GO_RETURN_STATE.CHECKED_MONEY_SUCCESS },
  { label: '退款成功', value: GO_RETURN_STATE.RETURNED_MONEY_SUCCESS },
  { label: '退款失败', value: GO_RETURN_STATE.RETURNED_MONEY_FAILED },
  { label: '退货已取消', value: GO_RETURN_STATE.RETURNED_CANCEL },
  { label: '退款已取消', value: GO_RETURN_STATE.RETURNED_MONEY_CANCEL },
  { label: '已完成', value: GO_RETURN_STATE.FINISHED },
];

@Component
export default class OrdersManage extends Vue {
  /* 数据 */

  /**
   * 列表状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 订单状态
   * @type {string}
   */
  public orderState = '';
  /**
   * 订单列表
   * @type {Array<OrderList>}
   */
  public orderList: Array<OrderList> = [];

  public dialogFlag = false;
  public dialogFlag2 = false;

  public orderDetailData: any = {};
  public targetItem: any = {};

  public TMoney: number | string = '';

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;
  /**
   * 选中的列表
   * @type
   */
  public selectedList = [];

  // 展示限制

  public isShow = false;

  // 是否展示订单明细的操作列
  public isShowDetail=false

  /* 方法 */

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchOrderList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getOrderList();
  }

  /**
   * 获取订单列表
   * @return null
   */
  public getOrderList(): void {
    this.orderList = [];
    const postParams = {
      orderState: this.orderState ? Number(this.orderState) : 9, // 订单状态 : (1待付款、2待发货、3待收货、4待评价 5已完成 6已取消 7推送失败 9所有)
      page: this.page,
      pageNum: this.pageSize,
      keywords: this.keywords,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('下单时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    IPSService.orderList({ postParams })
      .then((res) => {
        this.totalCount = res.count;
        this.orderList = (res.list || []).map((item) => {
          item.buyerHeader = Functions.emptyVaribleHandler(item.buyerInfo.buyerHeader);
          item.buyerName = item.buyerInfo.buyerName;
          item.buyerMobile = item.buyerInfo.buyerMobile;
          item.isCanCancel = item.act.isCanCancel;
          item.isCanPayReturn = item.act.isCanPayReturn;
          item.siteName = Functions.emptyVaribleHandler(item.siteName);
          item.orderSn = Functions.emptyVaribleHandler(item.orderSn);
          item.stateText = Functions.emptyVaribleHandler(item.stateText);
          item.orderTime = Functions.emptyVaribleHandler(item.orderTime);
          item.payTime = Functions.emptyVaribleHandler(item.payTime);
          if (this.isShow) {
            item.invoiceState = item.invoiceState === 0 ? '否' : '是';
          }
          return item;
        });
        loading.close();
      })
      .catch(() => loading.close());
  }

  public getState(row) {
    // return row.isPost ? "已发货" :  !row.isPost && !row.returnState ? "已付款" : this.ReturnStateText[row.returnState]
    if (row.isPost) {
      if (row.returnState == 100) {
        return this.ReturnStateText[11].label;
      }
      return '已发货';
    }

    if (!row.isPost && !row.returnState&&!this.isShowDetail) {
      return '已付款';
    }
    if (!row.isPost && !row.returnState&&this.isShowDetail) {
      return '已取消';
    }
    if (row.isCanReturn == 2) {
      // isCanReturn 0:off 1:on 2:outService 3:off(Need force to open) 4:on(Need force to off)
      return '超过售后时间';
    }

    return this.ReturnStateText[row.returnState - 1].label;
  }

  public ReturnStateText: any = GOrderReturnStateText;

  /**
   * 取消订单
   * @param {OrderList} item
   */
  public onOrderCancel(item: OrderList): void {
    this.$confirm('是否确认取消订单？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        orderId: item.orderId,
      };
      IPSService.orderCancel({ postParams }).then((res) => {
        if (res) {
          this.$message.success('取消成功');
          this.getOrderList();
        } else {
          this.$message.warning('取消失败');
        }
      });
    });
  }

  /**
   * 发起退款
   * @param {OrderList} item
   */
  public onOrderReturn(item: OrderList): void {
    this.$confirm('是否确认发起退款？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        orderId: item.orderId,
      };
      IPSService.orderReturn({ postParams }).then((res) => {
        if (res) {
          this.getOrderList();
          this.$message.success('退款成功');
        } else {
          this.$message.warning('退款失败');
        }
      });
    });
  }

  /**
   * 订单状态改变
   * @params {string} val
   * @return null
   */
  public onOrderStateChange(val: string): void {
    this.orderState = val;
    this.page = 1;
    this.pageSize = 10;
    this.getOrderList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getOrderList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getOrderList();
  }

  public dateChange() {
    this.page = 1;
    this.getOrderList();
  }
  /* 周期 */

  public created() {
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    this.date = [this.defaultStart, this.defaultEnd];
    const list = ['really', 'test001', 'demoenv', 'devtest2'];
    this.isShow = showPlatform(list);
    this.getOrderList();
  }

  // 查看订单明细
  public openDetail(orderId, orderState) {
    this.orderDetail(orderId);
    if(orderState == 7 ||orderState == 8){
      this.isShowDetail=true
    }else{
      this.isShowDetail=false
    }
  }

  public orderDetail(orderId) {
    const me = this;
    IPSService.getOrderDetail({ postParams: { orderId } }).then((res: any) => {
      if (res) {
        me.orderDetailData = res.list || [];
        me.dialogFlag = true;
      } else {
        me.$message.warning('接口错误');
      }
    });
  }

  /**
   * 选中的
   * @param {Array<SiteList2>} val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
    this.selectedList = val;
  }

  public handleInvoiceInfo() {
    if (!this.selectedList.length) {
      return;
    }
    this.$confirm('确定将所选订单设置为线下已开票状态吗？（注意：此操作不可逆）').then((res) => {
      const outnos
        = this.selectedList.map((i) => {
          return i.orderSn;
        }) || [];
      const orderIds
        = this.selectedList.map((i) => {
          return i.orderId;
        }) || [];
      if (res === 'confirm') {
        IPSService.orderInvoice({ postParams: { outnos } }).then((res) => {
          if (res.code === 0) {
            IPSService.orderOfflineInvoicingSign({ postParams: { orderIds } }).then((res) => {
              if (res.result) {
                this.getOrderList();
              }
            });
            this.$message.success('设置成功');
          }
        });
      }
    });
  }

  // 更新售后状态
  updateState(ospId, type) {
    if (type === 1) {
      this.$confirm('确定开启售后入口？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.orderUpdateState(type, ospId);
          if (ospId.canReturn !== 1) {
            ospId.isShow = false;
          } else {
            ospId.isShow = true;
          }
        }
      });
    } else if (type === 0) {
      this.$confirm('确定关闭售后入口？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.orderUpdateState(type, ospId);
          ospId.isShow = false;
        }
      });
    } else if (type === 2) {
      this.$confirm('是否强制开启售后入口？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.orderUpdateState(type, ospId);
          ospId.isShow = true;
        }
      });
    }
  }
  // 关闭售后

  orderUpdateState(isCanReturn, ospId = null): void {
    IPSService.orderStateSwitch({
      postParams: {
        isCanReturn,
        ospId: ospId.ospId,
      },
    }).then(() => {
      this.$message.success('操作成功');
      if (isCanReturn === -1) {
        this.page = 1;
      }
      this.orderDetail(ospId.orderId);
    });
  }

  openReturn(row) {
    this.targetItem = row || {};
    this.TMoney = this.targetItem.goodsAmount;
    this.dialogFlag2 = true;
  }

  public submitOrder() {
    Functions.limitClick(1000).then(async(res) => {
      const me = this;
      if (this.TMoney > this.targetItem.goodsAmount) {
        me.$message.warning('退款金额超过最大可退金额');
        return false;
      }
			const postParams = {
				orderId: this.targetItem.orderId,
				goodsSku: this.targetItem.goodsSku,
				goodsAmount: Number(this.TMoney),
			}
			if(this.targetItem.ospId) {
				postParams['ospId'] = this.targetItem.ospId
			}
      IPSService.orderReturnSave({
        postParams
      }).then((res: any) => {
        if (res) {
          me.dialogFlag2 = false;
          me.$message.success('提交成功');

          me.orderDetail(me.targetItem.orderId);
        } else {
          me.$message.warning('接口错误');
        }
      });
    });
  }
}
